// i18n keys of batch 10 round 2 (PAY-6): the employee change log's Admin view (Admin › Audit Log ›
// Employee changes, src/components/Admin/EmployeeChangeLog.tsx) and the "no access" cell O2 puts where
// a salary would be (src/components/ClientOnboard/editors.tsx EmployeeEditor, ClientDashboard), en / zh / th.
// ⛔ Fill all three: an empty value falls back or renders blank. ⛔ Counted keys are _one / _other —
// `_plural` is dead in i18next 23.
// ⛔ ONLY THE SCREENS' OWN WORDS. Client and employee names, the values a change moved from and to, who
// made it and the source it came through are data, shown exactly as recorded in every language.
export const en: Record<string, string> = {
  ecl_pay_hidden: '— No access',
  ecl_pay_hidden_tip: 'Salary, withholding tax and social security are shown only to administrators and to staff with Accounting books access for this client. Saving here leaves them unchanged.',
  ecl_view_docs: 'Documents',
  ecl_view_employees: 'Employee changes',
  ecl_lead: 'Every change to an employee record, newest first: who made it, when, through which screen or request, and what each field was before and after. Salaries are included, so only administrators can see this log, and nobody can edit it.',
  ecl_filter_client: 'Client',
  ecl_all_clients: 'All clients',
  ecl_rows_one: '{{count}} change',
  ecl_rows_other: '{{count}} changes',
  ecl_empty: 'No employee change has been recorded yet.',
  ecl_load_failed: 'The employee change log could not be loaded: {{error}}',
  ecl_col_when: 'When',
  ecl_col_client: 'Client',
  ecl_col_employee: 'Employee',
  ecl_col_change: 'Change',
  ecl_col_who: 'By',
  ecl_col_source: 'Through',
  ecl_act_create: 'Added',
  ecl_act_update: 'Changed',
  ecl_act_remove: 'Removed',
  ecl_act_restore: 'Restored',
  ecl_blank: '(blank)',
  ecl_field_name: 'Name',
  ecl_field_name_en: 'English name',
  ecl_field_id_number: 'Tax ID',
  ecl_field_sso_id: 'Social security ID',
  ecl_field_nationality: 'Nationality',
  ecl_field_position: 'Position',
  ecl_field_monthly_salary: 'Monthly salary',
  ecl_field_sso_status: 'Social security start date',
  ecl_field_termination_date: 'Last day of employment',
  ecl_field_wht_override: 'Withholding tax (fixed)',
  ecl_field_sso_override: 'Social security (fixed)',
  ecl_field_id_doc_id: 'ID document',
  ecl_field_pnd1_allowances: 'PND.1 allowances',
  ecl_field_source: 'Came from',
  ecl_field_deleted: 'Removed',
};

export const zh: Record<string, string> = {
  ecl_pay_hidden: '— 无权限',
  ecl_pay_hidden_tip: '工资、预扣税和社保只向管理员以及对该客户有「会计账簿」权限的员工显示。在这里保存不会改动它们。',
  ecl_view_docs: '单据',
  ecl_view_employees: '员工变更',
  ecl_lead: '员工资料的每一次改动，最新的在前：谁改的、什么时候、经由哪个界面或申请，以及每个字段改前和改后的值。其中包括工资，所以只有管理员能看这份日志，任何人都不能修改它。',
  ecl_filter_client: '客户',
  ecl_all_clients: '全部客户',
  ecl_rows_one: '{{count}} 条变更',
  ecl_rows_other: '{{count}} 条变更',
  ecl_empty: '还没有任何员工变更记录。',
  ecl_load_failed: '员工变更日志加载失败：{{error}}',
  ecl_col_when: '时间',
  ecl_col_client: '客户',
  ecl_col_employee: '员工',
  ecl_col_change: '变更',
  ecl_col_who: '操作人',
  ecl_col_source: '经由',
  ecl_act_create: '新增',
  ecl_act_update: '修改',
  ecl_act_remove: '删除',
  ecl_act_restore: '恢复',
  ecl_blank: '（空）',
  ecl_field_name: '姓名',
  ecl_field_name_en: '英文名',
  ecl_field_id_number: '税号',
  ecl_field_sso_id: '社保号',
  ecl_field_nationality: '国籍',
  ecl_field_position: '职位',
  ecl_field_monthly_salary: '月薪',
  ecl_field_sso_status: '社保起始日',
  ecl_field_termination_date: '最后在职日',
  ecl_field_wht_override: '预扣税（固定值）',
  ecl_field_sso_override: '社保（固定值）',
  ecl_field_id_doc_id: '证件文件',
  ecl_field_pnd1_allowances: 'PND.1 减除项',
  ecl_field_source: '来源',
  ecl_field_deleted: '已删除',
};

export const th: Record<string, string> = {
  ecl_pay_hidden: '— ไม่มีสิทธิ์',
  ecl_pay_hidden_tip: 'เงินเดือน ภาษีหัก ณ ที่จ่าย และประกันสังคม แสดงเฉพาะผู้ดูแลระบบและพนักงานที่มีสิทธิ์สมุดบัญชีของลูกค้ารายนี้ การบันทึกที่หน้านี้จะไม่เปลี่ยนค่าเหล่านี้',
  ecl_view_docs: 'เอกสาร',
  ecl_view_employees: 'การเปลี่ยนแปลงข้อมูลพนักงาน',
  ecl_lead: 'ทุกการเปลี่ยนแปลงข้อมูลพนักงาน ล่าสุดอยู่บนสุด: ใครเปลี่ยน เมื่อไร ผ่านหน้าจอหรือคำขอใด และค่าของแต่ละช่องก่อนและหลัง รวมถึงเงินเดือน จึงมีเพียงผู้ดูแลระบบที่ดูบันทึกนี้ได้ และไม่มีผู้ใดแก้ไขได้',
  ecl_filter_client: 'ลูกค้า',
  ecl_all_clients: 'ลูกค้าทั้งหมด',
  ecl_rows_one: '{{count}} รายการ',
  ecl_rows_other: '{{count}} รายการ',
  ecl_empty: 'ยังไม่มีการบันทึกการเปลี่ยนแปลงข้อมูลพนักงาน',
  ecl_load_failed: 'โหลดบันทึกการเปลี่ยนแปลงข้อมูลพนักงานไม่สำเร็จ: {{error}}',
  ecl_col_when: 'เวลา',
  ecl_col_client: 'ลูกค้า',
  ecl_col_employee: 'พนักงาน',
  ecl_col_change: 'การเปลี่ยนแปลง',
  ecl_col_who: 'โดย',
  ecl_col_source: 'ผ่านทาง',
  ecl_act_create: 'เพิ่ม',
  ecl_act_update: 'แก้ไข',
  ecl_act_remove: 'ลบ',
  ecl_act_restore: 'กู้คืน',
  ecl_blank: '(ว่าง)',
  ecl_field_name: 'ชื่อ',
  ecl_field_name_en: 'ชื่อภาษาอังกฤษ',
  ecl_field_id_number: 'เลขประจำตัวผู้เสียภาษี',
  ecl_field_sso_id: 'เลขประกันสังคม',
  ecl_field_nationality: 'สัญชาติ',
  ecl_field_position: 'ตำแหน่ง',
  ecl_field_monthly_salary: 'เงินเดือน',
  ecl_field_sso_status: 'วันที่เริ่มประกันสังคม',
  ecl_field_termination_date: 'วันทำงานวันสุดท้าย',
  ecl_field_wht_override: 'ภาษีหัก ณ ที่จ่าย (กำหนดเอง)',
  ecl_field_sso_override: 'ประกันสังคม (กำหนดเอง)',
  ecl_field_id_doc_id: 'เอกสารประจำตัว',
  ecl_field_pnd1_allowances: 'ค่าลดหย่อน ภ.ง.ด.1',
  ecl_field_source: 'ที่มา',
  ecl_field_deleted: 'ลบแล้ว',
};
